import React, { ReactElement, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import BaremetalFirewall from "components/baremetal/manage/BaremetalFirewall";
import IconSelector from "components/shared/images/IconSelector";

import { getBaremetalFirewalls } from "redux/handlers/baremetalHandle";

import { getBaremetalFirewall } from "redux/selectors/baremetalSelector";

import { useAppDispatch } from "hooks/reduxHook";

const BaremetalFirewallPage = (): ReactElement => {
 const dispatch = useAppDispatch();
 const params = useParams<{ id: string; section: string }>();

 const firewall = useSelector(getBaremetalFirewall);

 const [loading, setLoading] = useState<boolean>(true);

 useEffect(() => {
  (async () => {
   if (params.id) {
    if (firewall?.barmetal_id_db !== Number(params.id)) {
     await dispatch(getBaremetalFirewalls(Number(params.id)));
    }
   }
   setLoading(false);
  })();
 }, [params.id]);

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px" }}>
   <Stack p={2} spacing={2}>
    <Stack direction="row" spacing={1}>
     <IconSelector icon="FirewallIcon" props={{ fontSize: "medium", color: "kxOrange" }} />
     <Typography fontSize={16} ml={1} variant="unboundedTitle">
      <FormattedMessage id="baremetal.firewall" />
     </Typography>
    </Stack>
   </Stack>
   <Stack p={2}>{loading ? <CircularProgress /> : <BaremetalFirewall />}</Stack>
  </Paper>
 );
};

export default BaremetalFirewallPage;
